module.exports = __webpack_public_path__ + "img/icon-45.d4e7044f.svg";